<template>
  <div class="page">
    <a-row style="margin-bottom: 8px;">
      <a-form layout="inline" :form="form" @submit="handleSearch">
        <a-form-item :label="`关键字`">
          <a-input :span="10" v-decorator="[`kw`]" placeholder="设置名称"/>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">搜索</a-button>
          <a-button :style="{ marginLeft: '8px' }" @click="clearSearchForm">清空</a-button>
        </a-form-item>
        <a-form-item style="margin-left: 16px;">
          <a-button type="primary" @click="addSettingItem">添加设置项</a-button>
        </a-form-item>
      </a-form>
    </a-row>
    <a-table :columns="table.header" :data-source="data"  :loading="table.loading" rowKey="id" :scroll="{y: table.scrollHeight}">
      <span slot="businessType" slot-scope="item">{{typeName(item.businessType)}}</span>
      <div slot="enable" slot-scope="item">
        <a-switch v-model="item.enable" checked-children="启用" un-checked-children="禁用"  @change="switchEnable(item)" />
      </div>
      <div slot="ops" slot-scope="item">
        <a-button class="ops-button" type="primary" @click="editRow(item)">编辑</a-button>
        <a-button class="ops-button" @click="deleteRow(item)">删除</a-button>
      </div>
    </a-table>
    <!--添加文档模板-->
    <a-modal
        title="添加设置项"
        width="60vw"
        :mask-closable="false"
        :ok-text="`确定`"
        :cancel-text="`取消`"
        :visible="modal.addSettingItem.show"
        :confirm-loading="modal.addSettingItem.confirmLoading"
        :dialog-style="{minWidth: '700px',maxWidth: '900px',top: '30%',marginTop: '-100px'}"
        @ok="addConfirm"
        @cancel="addCancel">
      <a-form :form="modal.addSettingItem.form" :label-col="{span:'6'}" :wrapper-col="{span: 14}">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="`key`">
              <a-input v-decorator="[`key`,{rules: [{required: true,message: '请输入key'}]}]" placeholder="key"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="`设置名称`">
              <a-input v-decorator="[`settingName`,{rules: [{required: true,message: '请输入设置名称'}]}]" placeholder="设置名称"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="`默认值`">
              <a-input v-decorator="[`defaultValue`,{rules: [{required: true,message: '请输入默认值'}]}]" placeholder="默认值"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="`业务类型`">
              <a-select :default-value="1" v-model="modal.addSettingItem.model.businessType" placeholder="选择业务类型">
                <a-select-option :value="1">项目设置</a-select-option>
                <a-select-option :value="2">楼栋设置</a-select-option>
                <a-select-option :value="3">房间设置</a-select-option>
                <a-select-option :value="4">车位设置</a-select-option>
                <a-select-option :value="5">业主设置</a-select-option>
                <a-select-option :value="6">抄表设置</a-select-option>
                <a-select-option :value="7">财务设置</a-select-option>
                <a-select-option :value="8">变更设置</a-select-option>
                <a-select-option :value="9">审批设置</a-select-option>
                <a-select-option :value="10">报表设置</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="排序">
              <a-input-number v-model="modal.addSettingItem.model.sort" :min="0"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="描述">
              <a-textarea v-decorator="[`des`]"  placeholder="描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea v-decorator="[`remarks`]" placeholder="备注信息"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--编辑文档模板-->
    <a-modal
        title="编辑设置项"
        width="60vw"
        :mask-closable="false"
        :ok-text="`确定`"
        :cancel-text="`取消`"
        :visible="modal.editSettingItem.show"
        :confirm-loading="modal.editSettingItem.confirmLoading"
        :dialog-style="{minWidth: '700px',maxWidth: '900px',top: '30%',marginTop: '-100px'}"
        @ok="editConfirm"
        @cancel="editCancel">
      <a-form :form="modal.editSettingItem.form" :label-col="{span:'6'}" :wrapper-col="{span: 14}">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="`key`">
              <a-input v-decorator="[`key`,{rules: [{required: true,message: '请输入key'}]}]" placeholder="key"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="`设置名称`">
              <a-input v-decorator="[`settingName`,{rules: [{required: true,message: '请输入设置名称'}]}]" placeholder="设置名称"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="`默认值`">
              <a-input v-decorator="[`defaultValue`,{rules: [{required: true,message: '请输入默认值'}]}]" placeholder="默认值"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="`业务类型`">
              <a-select v-model="modal.editSettingItem.model.businessType" placeholder="选择业务类型">
                <a-select-option :value="1">项目设置</a-select-option>
                <a-select-option :value="2">楼栋设置</a-select-option>
                <a-select-option :value="3">房间设置</a-select-option>
                <a-select-option :value="4">车位设置</a-select-option>
                <a-select-option :value="5">业主设置</a-select-option>
                <a-select-option :value="6">抄表设置</a-select-option>
                <a-select-option :value="7">财务设置</a-select-option>
                <a-select-option :value="8">变更设置</a-select-option>
                <a-select-option :value="9">审批设置</a-select-option>
                <a-select-option :value="10">报表设置</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="排序">
              <a-input-number v-model="modal.editSettingItem.model.sort" :min="0"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="描述">
              <a-textarea v-decorator="[`des`]"  placeholder="描述"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="备注">
              <a-textarea v-decorator="[`remarks`]" placeholder="备注信息"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import SettingItemService from "@/service/SettingItemService";

export default {
  name: "SettingItem",
  data(){
    return {
      pagination:{
        current: 1,
        total: 0,
        pageSize: 10
      },
      kw: null,
      table: {
        loading: true,
        header: [
          {
            title: 'key',
            width: 200,
            dataIndex: 'key'
          },
          {
            title: '设置名称',
            width: 200,
            dataIndex: 'settingName'
          },
          {
            title: '默认值',
            width: 200,
            dataIndex: 'defaultValue'
          },
          {
            title: '业务类型',
            width: 150,
            scopedSlots: {customRender: 'businessType'}
          },
          {
            title: '排序号',
            width: 200,
            dataIndex: 'sort'
          },
          {
            title: '启用',
            scopedSlots: {customRender: 'enable'}
          },
          {
            title: '描述',
            dataIndex: 'des'
          },
          {
            title: '备注',
            dataIndex: 'remarks'
          },
          {
            title: '操作',
            scopedSlots: {customRender: 'ops'}
          },
        ],
        locale: {
          emptyText: '暂无数据'
        },
        scrollHeight: 0
      },
      form: this.$form.createForm(this,{name: 'searchForm'}),
      expand: false,
      data:[],
      modal: {
        addSettingItem: {
          show: false,
          confirmLoading: false,
          form: this.$form.createForm(this,{name: 'createForm'}),
          model: {
            businessType: 1,
            enable: true,
            sort: 0
          }
        },
        editSettingItem: {
          key: null,
          show: false,
          confirmLoading: false,
          form: this.$form.createForm(this,{name: 'editForm'}),
          model: {
            businessType: 1,
            enable: true,
            sort: 0
          }
        }
      }
    }
  },
  methods: {
    clearSearchForm(){
      this.form.resetFields();
    },
    handleSearch(e){
      e.preventDefault();
      let _this = this;
      this.form.validateFields((err,values)=>{
        if (!err){
          _this.pagination.current = 1;
          _this.pagination.total = 0;
          _this.kw = values.kw;
          _this.reloadData();
        }
      });
    },
    addSettingItem(){
      this.modal.addSettingItem.show = true;
    },
    addConfirm(e){
      e.preventDefault();
      let _this = this;
      this.modal.addSettingItem.form.validateFields((err,values)=>{
        if (!err){
          values.enable = this.modal.addSettingItem.model.enable;
          values.businessType = this.modal.addSettingItem.model.businessType;
          console.log('验证通过',values);

          this.$confirm({
            title: '确定提交以上信息吗？',
            content: '请仔细核对信息后再提交',
            onOk(){
              _this.modal.addSettingItem.confirmLoading = true;
              SettingItemService.add(values).then(data=>{
                _this.modal.addSettingItem.confirmLoading = false;
                _this.modal.addSettingItem.show = false;
                _this.modal.addSettingItem.form.resetFields();
                _this.reloadData();
              }).catch(e=>{
                _this.$message.error(e);
                _this.modal.addSettingItem.confirmLoading = false;
              })
            }
          })

        }
      })
    },
    addCancel(){
      this.modal.addSettingItem.form.resetFields();
      this.modal.addSettingItem.show = false;
    },
    editRow(item){
      this.modal.editSettingItem.show = true;
      this.modal.editSettingItem.key = item.key;
      this.modal.editSettingItem.model.businessType = item.businessType;
      this.modal.editSettingItem.model.enable = item.enable;
      this.$nextTick(()=>{
        this.modal.editSettingItem.form.setFieldsValue(item);
      });
    },
    editConfirm(e){
      e.preventDefault();
      let _this = this;
      this.modal.editSettingItem.form.validateFields((err,values)=>{
        if (!err){
          values.enable = this.modal.editSettingItem.model.enable;
          values.businessType = this.modal.editSettingItem.model.businessType;
          console.log('验证通过',values);
          this.$confirm({
            title: '确定提交以上信息吗？',
            content: '请仔细核对信息后再提交',
            onOk(){
              _this.modal.editSettingItem.confirmLoading = true;
              SettingItemService.update(_this.modal.editSettingItem.key,values).then(data=>{
                _this.modal.editSettingItem.confirmLoading = false;
                _this.modal.editSettingItem.show = false;
                _this.modal.editSettingItem.form.resetFields();
                _this.reloadData();
              }).catch(e=>{
                _this.$message.error(e);
                _this.modal.editSettingItem.confirmLoading = false;
              })
            }
          })
        }
      })
    },
    editCancel(){
      this.modal.editSettingItem.form.resetFields();
      this.modal.editSettingItem.show = false;
    },
    deleteRow(item){
      let _this = this;
      this.$confirm({
        title: '确定删除该设置项吗？',
        content: '点击确认删除',
        onOk(){
          SettingItemService.delete(item.key).then(data=>{
            console.log("删除成功");
            _this.reloadData();
          }).catch(e=>{
            console.log("e",e);
            _this.$message.error(e);
          })
        }
      })
    },
    reloadData(){
      SettingItemService.getPageList(this.pagination.current,this.pagination.pageSize,this.kw).then((data)=>{
        this.table.loading = false;
        this.data = data.list;
      }).catch(e=>{
        this.table.loading = false;
        this.$message.error("数据获取失败");
      })
    },
    handleChange(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    typeName(index){
      return ["项目设置", "楼栋设置", "房间设置", "车位设置", "业主设置","抄表设置","财务设置","变更设置","审批设置","报表设置"][index-1];;
    },
    switchEnable(item){
      let _this = this;
      this.$confirm({
        title: "确定" + (item.enable?"启用":"禁用") + "该文档模板吗？",
        content: '点击确定生效',
        onOk(){
          SettingItemService.switchEnable(item.key,item.enable).then(da=>{
            console.log("切换成功");
          }).catch(e=>{
            console.log("e",e);
            _this.$message.error(e);
            item.enable = !item.enable;
          })
        }
      });
    },
  },
  mounted() {
    this.reloadData();
    this.table.scrollHeight = (document.documentElement.clientHeight || document.body.clientHeight) - 280
    console.log("sc",this.table.scrollHeight)
  }
}
</script>

<style scoped>

</style>
